import { __awaiter, __generator } from "tslib";
import { CreationError, } from '@office-start/create-types';
import { launchUrl } from '@office-start/launcher-service';
// Temporary wrapper class on launcherService. Revisit after LauncherService finalized
export function launchUrlWrapper(url, targetTab, linkTarget) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var launchResult, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, launchUrl(url, {
                            action: 'OpenFile',
                            targetTab: targetTab !== null && targetTab !== void 0 ? targetTab : undefined,
                            linkTarget: targetTab ? '_top' : linkTarget,
                        })];
                case 1:
                    launchResult = _c.sent();
                    if (!launchResult.result ||
                        launchResult.result === 'OpenNull' ||
                        launchResult.result === 'OpenUndefined') {
                        throw new CreationError("Open blocked by pop-up blocker for the newly created file.", "OpenBlockedByPopupBlocker" /* CreateDocumentResultType.OpenBlockedByPopupBlocker */);
                    }
                    if (!launchResult.success) {
                        throw new CreationError((_a = launchResult.message) !== null && _a !== void 0 ? _a : "Failed to launch newly created file.", "OpenNewDocFailed" /* CreateDocumentResultType.OpenNewDocFailed */);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    // TODO: logging if needed
                    return [2 /*return*/, Promise.resolve({
                            type: (_b = error_1.type) !== null && _b !== void 0 ? _b : "OpenNewDocFailed" /* CreateDocumentResultType.OpenNewDocFailed */,
                            documentWebUrl: url,
                        })];
                case 3: return [2 /*return*/, Promise.resolve({ type: "GoToBlankDoc" /* CreateDocumentResultType.GoToBlankDoc */ })];
            }
        });
    });
}
//# sourceMappingURL=launchUrlWrapper.js.map